import type { FaireProductEntity } from "../../entity_types/product";

export const p_bnaxct7cg4: FaireProductEntity = {
  token: "p_bnaxct7cg4",
  type: "product",
  name: "Hexagonal Pyramid Crystal Stone Pendulum",
  brandToken: "b_pxpb5s3cxg",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/cff6a99b0c442b3c5fb851bed21262ac2faa83bd78deb0a7591abc6659956db2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f97526de2ba2643074b063e04df7c8fc9883cc49f463ed6b621517ec7d093a8f.jpeg",
    "https://cdn.faire.com/fastly/e202f449507cfa1f82febd961b89eeee8079279f7062d7c690ed25db65fda2d8.jpeg",
    "https://cdn.faire.com/fastly/ddc848440fd7ae8ccf941cca5397d92849cc2572a6772df09aaccf6bcf5da5fd.jpeg",
    "https://cdn.faire.com/fastly/abfa40dfeb17c1117371c85039ff0affaf2dcca500134eec969b5f4c2a157e36.jpeg",
    "https://cdn.faire.com/fastly/705a1d27346f0828d934e1b38debfa00c76926cf1290e00bcf18db6edec39365.jpeg",
    "https://cdn.faire.com/fastly/07ba2650b4240c93626f42d14030e33b0701a1374f965c9519e85e257a202bcd.jpeg",
    "https://cdn.faire.com/fastly/05ffa1b2b4d4285bf29226ffd7af048b7cca569dcabe41337a9cfd649e216cef.jpeg",
    "https://cdn.faire.com/fastly/bc6a368eb7a1853d5f9b1562cc4f54aa12c3ad1dc24066e1af16c7151a6e71d2.jpeg",
    "https://cdn.faire.com/fastly/cea1e6d6ffc0dffa076843e079979480899b8b882bda0dc79fe36b48b06ad328.jpeg",
    "https://cdn.faire.com/fastly/adb37cad1d5b9a79708404b267ffd6e5b189f4fcd9a12339b1252c054dcaa913.jpeg",
    "https://cdn.faire.com/fastly/ff6cede664f59b9ca5156241b73c34f9780c46b69acd4ca8565bec2ec6542783.jpeg",
    "https://cdn.faire.com/fastly/bd2dc1aa7f1533b82494ff29201c7392e7e71df423c91dd2b4c02f6982ce1cfc.jpeg",
    "https://cdn.faire.com/fastly/9863150c4be7e120d6469070f7892cfaf4e70f063f67da5de38f5576d343ea01.jpeg",
    "https://cdn.faire.com/fastly/c2ad2b14444493050ef8c69a872493868126d13480f1a75cfec26a5306604549.jpeg",
    "https://cdn.faire.com/fastly/3d9fa5f9d19f6fd78a8ff11863a4e9435a3c48d2db9668c652e5472601b3cce2.jpeg",
    "https://cdn.faire.com/fastly/d6e9f99858a5f5ea07f2fd0d8b4f2c60d8f9830f3c35d95524b04d1d70eeb1f6.jpeg",
    "https://cdn.faire.com/fastly/cf0159fcf808769d5ecc92e603cad488f97aa2f5c4ea68650f3f1b2def7ba829.jpeg",
    "https://cdn.faire.com/fastly/bdd222ec78e0c948868e587617956f054c9c347f511d736694fe05944ca8ab64.jpeg",
    "https://cdn.faire.com/fastly/5e87253d937d7609b1bdeb15451a84435d19f08ab2bd0a704eeed7fc5cde3508.jpeg",
    "https://cdn.faire.com/fastly/fd0575e5c8fa0199d091256b0fa591e40ffdea4a882df55b898903f0dfb67637.jpeg",
    "https://cdn.faire.com/fastly/86d8a6453650b2d15add1037cf01c8c2f118bf6e9702670bf5cb7aff7c50fc31.jpeg",
    "https://cdn.faire.com/fastly/7d509b410389a28d33d08de611a01dfacac16af52bff292fb38f5962f254c79b.jpeg",
    "https://cdn.faire.com/fastly/4ba8111e1585c5ca5caf87c601b33ae7eb4e071f9876a634a9b764c17c34396d.jpeg",
  ],
  priceDollars: 6.93,
  description:
    "Material:Hexagon shape natural crystal stone pendulum.This pendulum is made of high quality crushed chip stone wrapped with resin.\nEffect: The stone Pendant is facets like crystal generator to promote clarity and concentration. The facets of stone will enhance the colour and enrich its own beauty. It is well polished to make you feel comfortable when it touch your skin.\n-ID: GEM-KS-P2416\n-Quality: Excellent\n-Lead Free, Nickel Free",
  tags: [],
  msrpDollars: 13.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:17.226Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
